import { datadogRum } from '@datadog/browser-rum';
import React, { useEffect, useRef } from 'react';

import { useAppConfig } from '../useAppConfig';

import Context from './Context';

import { Environment } from '../../../types';
import { DatadogRumConfig } from './types';

interface Props {
  children: React.ReactNode;
}

function DatadogRumProvider({ children }: Props) {
  const hasInjected = useRef<boolean>(false);
  const { appVersion, environment } = useAppConfig();
  const shouldInjectDatadogRum = environment === Environment.Production;

  const value: DatadogRumConfig = {
    applicationId: 'aa933469-e273-4f0f-bd77-3a332566123d',
    clientToken: 'pubafd6bd6f8559b5c8a12e4f841d7fbc61',
    site: 'datadoghq.com',
    service: 'talentsearch-ui-connected',
    env: environment,
    version: appVersion,
    sampleRate: 10,
    replaySampleRate: 10, // <-- percentage of sessions that will have replaying the session, set to zero to not record anything.
    useCrossSiteSessionCookie: true, // <-- allows the RUM SDK to run when the site is loaded from another one (iframe).
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  };
  datadogRum.setRumGlobalContext({
    ...datadogRum.getRumGlobalContext(),
    team: 'talent-search',
  });

  useEffect(() => {
    if (shouldInjectDatadogRum && !hasInjected.current) {
      datadogRum.init(value);

      // Uncomment the following line if you want the user sessions to be recorded for later playback.
      // datadogRum.startSessionReplayRecording();
    }
    hasInjected.current = true;
  });

  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export default DatadogRumProvider;
